import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PartnerInformation } from '../../core-data-model';
import { TranslationService } from '../../translations';

@Component({
    selector: 'billing-contact-details',
    template: `
        <div class="peek-panel-div">
            <div class="peek-panel-header">
                <div class="title-dashboard">
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-title'
                        )
                    }}
                </div>
                <div class="title-md">
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-subtitle'
                        )
                    }}
                </div>
            </div>
            <br /><br />
            <div>
                <div class="section-title">
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-detail-title'
                        )
                    }}
                </div>
                <br />
                <div>
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-detail-description'
                        )
                    }}
                </div>
                <br />
                <div class="section-title">
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-current-contact'
                        )
                    }}
                </div>
                <br />
                <div class="subsection-title">
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-current-contact-first-name'
                        )
                    }}
                </div>
                <div class="subsection-details" id="billing-contact-first-name">
                    {{ firstName }}
                </div>
                <br />
                <div class="subsection-title">
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-current-contact-last-name'
                        )
                    }}
                </div>
                <div class="subsection-details" id="billing-contact-last-name">
                    {{ lastName }}
                </div>
                <br />
                <div class="subsection-title">
                    {{
                        TR.key(
                            'billing-manager.billing-contact-peek-panel-current-contact-email'
                        )
                    }}
                </div>
                <div class="subsection-details" id="billing-contact-email">
                    {{ email }}
                </div>
                <br />
            </div>
            <div class="peek-panel-footer">
                <div class="layoutHorizontalSpacing">
                    <div>
                        <span>
                            {{
                                TR.key(
                                    'billing-manager.billing-contact-peek-panel-contact-update-instructions'
                                )
                            }}
                            <a href="{{ supportLink }}">
                                {{ supportCustomerService }}
                            </a>
                        </span>
                    </div>
                    <div class="peek-panel-footer-button-container">
                        <button
                            class="button button-md button-primary"
                            (click)="closeClick()"
                        >
                            {{ TR.key('label.common-terms.close') }}
                        </button>
                    </div>
                </div>
                <br />
            </div>
        </div>
    `,
    styleUrls: ['./account-billing-manager.less'],
    standalone: false
})
export class AccountBillingContactComponent implements OnInit {
    @Input()
    partnerInfo: PartnerInformation;

    @Output()
    closePanel = new EventEmitter<boolean>();

    firstName: string;
    lastName: string;
    email: string;
    supportLink: string;
    supportCustomerService: string;

    constructor(public TR: TranslationService) {}

    async ngOnInit() {
        const splitName = this.partnerInfo.accountMetadata
            .find((m) => m.name === 'billingContactName')
            .value.split(' ');

        this.email = this.partnerInfo.accountMetadata.find(
            (m) => m.name === 'billingContactEmail'
        ).value;

        this.firstName = splitName[0];
        this.lastName = splitName[1];

        this.supportLink = this.TR.key(
            'billing-manager.billing-contact-peek-panel-contact-email'
        );
        this.supportCustomerService = this.TR.key('customerservice');
    }

    closeClick() {
        this.closePanel.emit(false);
    }
}
